import useCore from 'modules/reports/hooks/core'
import React from 'react'
import ReportsIndexHeader from './Header'
import ReportsIndexPanel from './Panel'
import useStyles from './ReportsIndex.styles'
import ReportsIndexTable from './Table'

type Props = {
  className?: string
  title: React.ReactNode
  newHref: string
  newButtonText: React.ReactNode
}

function ReportsIndex(props: Props) {
  const classes = useStyles()
  const {className, title, newHref, newButtonText} = props
  const {p} = useCore('reports', 'components', 'Index')

  return (
    <div className={`${className} ${classes.root}`} data-testid={p()}>
      <ReportsIndexHeader title={title} newHref={newHref} newButtonText={newButtonText} />
      <ReportsIndexPanel />
      <ReportsIndexTable />
    </div>
  )
}

export default ReportsIndex
